/**
 * Redondeo half away from zero (mismo criterio que el backend): -850.945 → -850.95.
 * Math.round nativo redondea .5 hacia +Infinito y falla en negativos.
 */
export const roundHalfAwayFromZero = (value: number, decimals: number): number => {
  const factor = Math.pow(10, decimals)

  return (Math.sign(value) * Math.round(Math.abs(value) * factor)) / factor
}

/**
 * Criterio único de redondeo de dinero en el front: 2 decimales, half away from zero
 * (idéntico al backend). Usar para cálculos y comparaciones — NUNCA toFixed(), que
 * devuelve string y tiene casos raros de redondeo binario; toFixed solo para formatear.
 */
export const roundMoney = (value: number): number => roundHalfAwayFromZero(value, 2)
